/** Single source of truth for the lab's contact numbers: WhatsApp is for messages only, the phone is for calls only. */
export const LAB_WHATSAPP_NUMBER = '201050545050';
export const LAB_WHATSAPP_DISPLAY = '010 5054 5050';

export const LAB_CALL_NUMBER = '201006076325';
export const LAB_CALL_DISPLAY = '010 0607 6325';
